import { useTranslation } from "react-i18next";

export const useSelectViajeChecklist = () => {
    const { t } = useTranslation();
    const SELECT_VIAJE_CHECKLIST = [
        {
            value: 57,
            label: t('select_seleccionar_ruta'),
        },
        {
            value: 58,
            label: t('input_hora_de_paso'),
        },
        {
            value: 59,
            label: t('input_kilometro'),
        },
        {
            value: 60,
            label: t('input_tiempo_descanso'),
        },
        {
            value: 61,
            label: t('select_reportar_ubicacion'),
        },
        {
            value: 62,
            label: t('input_observacion'),
        },
    ];
    return SELECT_VIAJE_CHECKLIST;
};